import React from "react";
import {
    titleize,
    CURRENCY_EURO,
    isDefined,
    parseAmount,
    parseDateIsoFormat,
    convertToUTC,
    convertToLocal,
    convertToDate
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import IconTooltip from "./IconTooltip";
import ShipmentMethodForm from "./ShipmentMethodForm";


// FUNZIONI DI UTILITÀ USATE SOLAMENTE IN QUESTI COMPONENTI REACT
const allSaleChannelAttributes = (saleChannel, saleItem) => {
    return (saleChannel.sale_attributes.no_sale_method.filter(saleAttribute => !primarySaleAttribute(saleAttribute)).concat(saleItem?.sale_method && saleChannel.sale_attributes[saleItem.sale_method] ? saleChannel.sale_attributes[saleItem.sale_method] : [])).length + 2;
}

const parseSaleAttributeKey = (entity, key, defaultKey) => {
    return entity ? (entity[`${I18n.locale}_${key}`] ? entity[`${I18n.locale}_${key}`] :
        (entity[`en_${key}`] ? entity[`en_${key}`] :
            (key === 'name' ? titleize(entity[defaultKey])?.replaceAll('_', ' ') : ''))) : ''
}

const primarySaleAttribute = (saleAttribute) => {
    return saleAttribute?.trait_name && ['title', 'description'].includes(saleAttribute.trait_name);
}

const secondarySaleAttribute = (saleAttribute) => {
    return saleAttribute?.trait_name && ['listing_start_date'].includes(saleAttribute.trait_name);
}

const base3Serie = (count, startIndex = 0) => {
    return Array.from({ length: count + 1 }, (_, i) => i)
        .filter(i => i % 3 !== 3 - 1 - startIndex);
};

const notMultiples2 = (count) => {
    return Array.from({ length: count }, (_, i) => i).filter(n => n % 2 !== 0);
}

const multiples2 = (count) => {
    return Array.from({ length: count }, (_, i) => i).filter(n => n % 2 === 0);
}


const QuestionToolTip = ({
    message
}) => {
    return (
        <IconTooltip
            tooltipContent3={message}
            customComponentToRenderCssClass={'unexisting-class'}
            customComponentToRender={
                <React.Fragment>
                    <img
                        className="align-baseline"
                        src={window.location.origin + '/images/icons/question.svg'}
                        alt="" width="12px" />
                </React.Fragment>
            }
        />
    )
}


export const SaleItemFormLabel = ({
    saleAttribute,
    disabled,
    title,
    message,
    id
}) => {
    return (
        <div className="d-flex justify-content-start align-items-center mb-0">
            <p className={`default_small_label mr-1 mb-0 font-size-12px-imp ${disabled ? 'opacity-0_3-imp' : ''}`} id={id}>
                {saleAttribute ?
                    parseSaleAttributeKey(saleAttribute, 'name', 'trait_name').toUpperCase()
                    :
                    title.toUpperCase()
                }
            </p>
            <QuestionToolTip message={
                saleAttribute ?
                    parseSaleAttributeKey(saleAttribute, 'description', null)
                    :
                    message
            } />
        </div>
    )
}

const SaleAttributes = ({
    saleAttributes,
    saleItem,
    saleItemToParseValue,
    setSaleItemToUpdate,
    handleUpdateSaleItem,
    disableSaleAttributeInput,
    xlMarginRightIndexes,
    lgMarginRightIndexes,
    now,
    renderSaleAttributeValue
}) => {

    const handleUpdateSaleAttributes = (saleAttribute, value, applyDebounce = false) => {
        const newSaleAttributes = { ...saleItem.sale_attributes };
        newSaleAttributes[saleAttribute?.trait_name] = value;

        const nestedSaleAttributes = saleItem.sale_channel.sale_attributes.nested_sale_attributes;
        if (saleAttribute && nestedSaleAttributes) {
            const subSaleAttributes = nestedSaleAttributes[saleAttribute.trait_name];

            if (subSaleAttributes?.length > 0 && value?.toString() !== 'true')
                for (const subSaleAttribute of subSaleAttributes)
                    delete newSaleAttributes[subSaleAttribute]

        }

        if (applyDebounce)
            setSaleItemToUpdate({ oldSaleItem: { ...saleItem }, updatedSaleItem: { ...saleItemToParseValue, sale_attributes: newSaleAttributes } })
        else
            handleUpdateSaleItem({ ...saleItem, sale_attributes: newSaleAttributes })
    }


    const parseSaleAttributeInputFormValue = (saleAttribute) => {
        return saleItemToParseValue.sale_attributes && saleItemToParseValue.sale_attributes[saleAttribute.trait_name] ?
            saleItemToParseValue.sale_attributes[saleAttribute.trait_name]
            :
            '';
    }



    return (
        <React.Fragment>
            {
                saleAttributes.map((saleAttribute, index) =>
                    <React.Fragment key={saleAttribute.trait_name}>
                        <div className={`
                            col-12 
                            col-lg-${primarySaleAttribute(saleAttribute) ? '12' : '6'} 
                            col-xl-${primarySaleAttribute(saleAttribute) ? '12' : '4'} 
                            border-bottom-aiG-light-gray-imp 
                            ${lgMarginRightIndexes.includes(index) ? 'border-right-lg-aiG-light-gray-imp' : 'border-right-lg-none'}
                            ${xlMarginRightIndexes.includes(index) ? 'border-right-xl-aiG-light-gray-imp' : 'border-right-xl-none'}
                            ${primarySaleAttribute(saleAttribute) ? 'mt-1' : ''}
                            ${disableSaleAttributeInput(saleAttribute) ? 'cursor-not-allowed' : ''}
                        `}>
                            <div className="d-block pl-2">
                                <SaleItemFormLabel
                                    saleAttribute={saleAttribute}
                                    disabled={disableSaleAttributeInput(saleAttribute)}
                                    id={`${saleAttribute.trait_name}_${saleItem.id}_label`}
                                />

                                {
                                    saleItem.editable ?
                                        (
                                            saleAttribute.value_type === 'string' ?
                                                <input
                                                    id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                    type="text"
                                                    value={parseSaleAttributeInputFormValue(saleAttribute)}
                                                    className={`form-control sale-item-form-input border-left-radius-3px-imp w-100 mb-1 ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}`}
                                                    disabled={disableSaleAttributeInput(saleAttribute)}
                                                    placeholder={I18n.t('js.indexSaleItems.placeholders.fillThisField')}
                                                    required={saleAttribute.required}
                                                    onChange={(e) => {
                                                        handleUpdateSaleAttributes(saleAttribute, e.target.value?.replaceAll('"', "'"), true)
                                                    }}
                                                />
                                                :
                                                saleAttribute.value_type === 'text' ?
                                                    <textarea
                                                        id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                        rows="2" cols="40"
                                                        className={`form-control sale-item-form-input border-left-radius-3px-imp w-100 mb-1 ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}`}
                                                        value={parseSaleAttributeInputFormValue(saleAttribute).replaceAll('<br>', '\n').replaceAll('<br/>', '\n').replaceAll('<b>', '').replaceAll('</b>', '')}
                                                        disabled={disableSaleAttributeInput(saleAttribute)}
                                                        placeholder={I18n.t('js.indexSaleItems.placeholders.fillThisField')}
                                                        required={saleAttribute.required}
                                                        onChange={(e) => {
                                                            handleUpdateSaleAttributes(saleAttribute, e.target.value?.replaceAll('"', "'"), true)
                                                        }}
                                                    />
                                                    :
                                                    ['integer', 'float'].includes(saleAttribute.value_type) ?
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            step={saleAttribute.value_type === 'integer' ? "1" : "0.5"}
                                                            value={parseSaleAttributeInputFormValue(saleAttribute)}
                                                            className={`form-control sale-item-form-input border-left-radius-3px-imp w-100 mb-1 ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}`}
                                                            disabled={disableSaleAttributeInput(saleAttribute)}
                                                            placeholder={I18n.t('js.indexSaleItems.placeholders.typeAValue')}
                                                            required={saleAttribute.required}
                                                            onChange={(e) => {
                                                                handleUpdateSaleAttributes(saleAttribute, e.target.value, true)
                                                            }}
                                                            id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                        />
                                                        :
                                                        saleAttribute.value_type === 'boolean' ?
                                                            <select
                                                                className={`
                                                                    form-control sale-item-form-input mb-1
                                                                    sale-item-form-select ${(!saleItem.sale_attributes || !saleItem?.sale_attributes[saleAttribute.trait_name]) ? 'sale-item-form-placeholder' : ''} 
                                                                    ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}
                                                                `}
                                                                value={saleItem.sale_attributes && saleItem.sale_attributes[saleAttribute.trait_name] ? saleItem.sale_attributes[saleAttribute.trait_name] : ''}
                                                                id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                                disabled={disableSaleAttributeInput(saleAttribute)}
                                                                required={saleAttribute.required}
                                                                onChange={(e) => {
                                                                    handleUpdateSaleAttributes(saleAttribute, e.target.value)
                                                                }}
                                                            >
                                                                <option value={""}>
                                                                    {I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
                                                                </option>
                                                                {[[I18n.t('js.common.choice_yes'), true], [I18n.t('js.common.choice_no'), false]].map((choice) => (
                                                                    <option value={choice[1]} key={choice[1]}>
                                                                        {choice[0]}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            :
                                                            saleAttribute.value_type === 'price' ?
                                                                <input
                                                                    type="number"
                                                                    min="0.01"
                                                                    step="0.5"
                                                                    disabled={disableSaleAttributeInput(saleAttribute)}
                                                                    placeholder={I18n.t('js.indexSaleItems.placeholders.typeAnAmount')}
                                                                    required={saleAttribute.required}
                                                                    value={parseSaleAttributeInputFormValue(saleAttribute)}
                                                                    className={`form-control sale-item-form-input border-left-radius-3px-imp w-100 mb-1 ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}`}
                                                                    onChange={(e) => {
                                                                        handleUpdateSaleAttributes(saleAttribute, e.target.value, true)
                                                                    }}
                                                                    id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                                />
                                                                :
                                                                saleAttribute.value_type === 'enum' && saleAttribute.pools?.length > 0 ?
                                                                    <select
                                                                        className={`
                                                                            form-control sale-item-form-input mb-1
                                                                            sale-item-form-select ${(!saleItem.sale_attributes || !saleItem?.sale_attributes[saleAttribute.trait_name]) ? 'sale-item-form-placeholder' : ''} 
                                                                            ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}
                                                                        `}
                                                                        value={saleItem.sale_attributes && saleItem.sale_attributes[saleAttribute.trait_name] ? saleItem.sale_attributes[saleAttribute.trait_name] : ''}
                                                                        id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                                        disabled={disableSaleAttributeInput(saleAttribute)}
                                                                        required={saleAttribute.required}
                                                                        onChange={(e) => {
                                                                            handleUpdateSaleAttributes(saleAttribute, e.target.value)
                                                                        }}
                                                                    >
                                                                        <option value={""}>
                                                                            {I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
                                                                        </option>
                                                                        {saleAttribute.pools.map((pool) => (
                                                                            <option value={pool.value} key={pool.value}>
                                                                                {parseSaleAttributeKey(pool, 'name', 'value')}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    :
                                                                    saleAttribute.value_type === 'datetime' ?
                                                                        <input
                                                                            id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                                            min={isDefined(saleAttribute.min_value) ? now.clone().add(saleAttribute.min_value.split(' ')[0], saleAttribute.min_value.split(' ')[1]).format('YYYY-MM-DD HH:mm') : parseDateIsoFormat(new Date(), '%Y-%m-%d, %H:%M')}
                                                                            max={isDefined(saleAttribute.max_value) ? now.clone().add(saleAttribute.max_value.split(' ')[0], saleAttribute.max_value.split(' ')[1]).format('YYYY-MM-DD HH:mm') : null}
                                                                            type="datetime-local"
                                                                            value={parseSaleAttributeInputFormValue(saleAttribute) ? parseDateIsoFormat(convertToDate(parseSaleAttributeInputFormValue(saleAttribute)), "%Y-%m-%d, %H:%M") : ''}
                                                                            className={`
                                                                                form-control sale-item-form-input mb-1
                                                                                ${(!saleItem.sale_attributes || !saleItem?.sale_attributes[saleAttribute.trait_name]) ? 'sale-item-form-placeholder' : ''}
                                                                                border-left-radius-3px-imp w-100
                                                                                ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}
                                                                            `}
                                                                            disabled={disableSaleAttributeInput(saleAttribute)}
                                                                            required={saleAttribute.required}
                                                                            onChange={(e) =>
                                                                                handleUpdateSaleAttributes(saleAttribute, e.target.value ? parseDateIsoFormat(convertToUTC(e.target.value), "%Y-%m-%d, %H:%M:00.000Z") : null, true)
                                                                            }
                                                                        />
                                                                        :
                                                                        saleAttribute.value_type === 'date' &&
                                                                        <input
                                                                            id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                                            type="date"
                                                                            min={parseDateIsoFormat(new Date(), '%Y-%m-%d')}
                                                                            value={parseSaleAttributeInputFormValue(saleAttribute)}
                                                                            className={`
                                                                                form-control sale-item-form-input mb-1
                                                                                ${(!saleItem.sale_attributes || !saleItem?.sale_attributes[saleAttribute.trait_name]) ? 'sale-item-form-placeholder' : ''}
                                                                                border-left-radius-3px-imp w-100
                                                                                ${disableSaleAttributeInput(saleAttribute) ? 'opacity-0_3-imp' : ''}
                                                                            `}
                                                                            disabled={disableSaleAttributeInput(saleAttribute)}
                                                                            required={saleAttribute.required}
                                                                            onChange={(e) => {
                                                                                handleUpdateSaleAttributes(saleAttribute, e.target.value, true)
                                                                            }}
                                                                        />
                                        )
                                        :
                                        <p className="my-1">
                                            {saleItem.sale_attributes && saleItem.sale_attributes[saleAttribute.trait_name] ?
                                                (
                                                    saleAttribute.value_type !== 'text' ?
                                                        <span>{renderSaleAttributeValue(saleAttribute)}</span>
                                                        :
                                                        <textarea
                                                            id={`sale_attribute_${saleAttribute.trait_name}_${saleItem.id}`}
                                                            rows="1" cols="20"
                                                            className="form-control sale-item-form-input border-left-radius-3px-imp w-100 mb-1 py-1"
                                                            value={renderSaleAttributeValue(saleAttribute)}
                                                            disabled={true}
                                                            onChange={() => { }}
                                                        />
                                                )
                                                :
                                                I18n.t('js.indexSaleItems.listingForm.notSet')
                                            }
                                        </p>
                                }
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}


const SaleForm = ({
    saleItem,
    handleUpdateSaleItem,
    now,
    safeShipmentMethod,
    saleItemToUpdate,
    setSaleItemToUpdate,
    saleChannelsLinks
}) => {

    const saleChannel = saleItem.sale_channel;
    const saleChannelLink = saleChannelsLinks ? saleChannelsLinks[saleItem?.sale_channel?.meta_name] : null;
    const nationalCouriers = saleChannel?.couriers?.filter(courier => courier.type != 'international' && (!saleChannelLink?.favorite_marketplace || !courier.marketplace || courier.marketplace === saleChannelLink.favorite_marketplace))
    const internationalCouriers = saleChannel?.couriers?.filter(courier => courier.type == 'international' && (!saleChannelLink?.favorite_marketplace || !courier.marketplace || courier.marketplace === saleChannelLink.favorite_marketplace))
    const saleItemToParseValue = saleItemToUpdate?.updatedSaleItem?.id === saleItem.id ? saleItemToUpdate?.updatedSaleItem : saleItem;
    const primarySaleAttributes = saleChannel.sale_attributes.no_sale_method.filter(saleAttribute => primarySaleAttribute(saleAttribute));
    const secondarySaleAttributes = saleChannel.sale_attributes.no_sale_method.filter(saleAttribute => secondarySaleAttribute(saleAttribute));
    const otherSaleAttributes = (saleChannel.sale_attributes.no_sale_method.filter(saleAttribute => !primarySaleAttribute(saleAttribute) && !secondarySaleAttribute(saleAttribute))).concat(isDefined(saleItem?.sale_method) && saleChannel.sale_attributes[saleItem.sale_method] ? saleChannel.sale_attributes[saleItem.sale_method] : [])


    // Funzione che verifica se debba essere disabilitato un campo di input per impedire
    // all'utente di settare uno specifico parametro di vendita di un certo prodotto
    const disableSaleAttributeInput = (saleAttribute, disableMode = 'soft') => {
        if (saleItem.allow_changes) {
            if (disableMode === 'strong')
                return saleItem.editable && !['draft', 'expired'].includes(saleItem.state);
            return (
                saleItem.state === 'sold' ||
                ((isDefined(saleAttribute) && !saleAttribute.editable && !['draft', 'expired'].includes(saleItem.state)) ||
                    (saleItem.sale_method === 'auction' && isDefined(saleItem.offers_count) && saleItem.offers_count > 0 && !['draft', 'expired'].includes(saleItem.state)) ||
                    (isDefined(saleAttribute) && isDefined(saleAttribute.parent) && saleItem.sale_attributes[saleAttribute.parent]?.toString() !== 'true'))
            );
        } else
            return true;
    }


    // Funzione che aggiorna il saleMethod ed elimina i valori dei campi inerenti a tutti i saleMethod diversi da quello selezionato
    const handleUpdateSaleMethod = (newSaleMethod) => {
        const newSaleAttributes = { ...saleItem.sale_attributes };

        const previousSaleMethod = saleItem.sale_method;
        if (isDefined(previousSaleMethod)) {
            const saleAttributesToReset = saleItem.sale_channel.sale_attributes[previousSaleMethod].map(saleAttribute => saleAttribute.trait_name);
            for (const saleAttributeToReset of saleAttributesToReset)
                delete newSaleAttributes[saleAttributeToReset]
        }

        const saleAttributesBySaleMethod = saleItem.sale_channel.sale_attributes[newSaleMethod];
        const enumSaleAttributes = saleAttributesBySaleMethod.filter(saleAttribute => saleAttribute.value_type === 'enum');
        for (const saleAttribute of enumSaleAttributes) {
            const pools = saleAttribute.pools;
            const defaultPoolValue = pools.filter(pool => pool.default.toString() === 'true')
            if (defaultPoolValue?.length > 0)
                newSaleAttributes[saleAttribute.trait_name] = defaultPoolValue[0].value
        }

        handleUpdateSaleItem({ ...saleItem, sale_method: newSaleMethod, sale_attributes: newSaleAttributes })
    }


    // Funzione renderizza il valore non editabile di un saleAttribute in base al suo tipo
    const renderSaleAttributeValue = (saleAttribute) => {
        const unparsedValue = saleItem.sale_attributes[saleAttribute.trait_name];
        switch (saleAttribute.value_type) {
            case 'enum':
                return parseSaleAttributeKey(saleAttribute.pools.filter(pool => pool.value.toUpperCase() == unparsedValue.toUpperCase())[0], 'name', 'value');
            case 'boolean':
                return I18n.t(`js.common.choice_${unparsedValue ? 'yes' : 'no'}`);
            case 'price':
            case 'float':
                return `${parseAmount(unparsedValue, 2, true)}${CURRENCY_EURO}`;
            case 'datetime':
                return parseDateIsoFormat(convertToDate(unparsedValue), "%d-%m-%Y, %H:%M");
            case 'date':
                return parseDateIsoFormat(convertToLocal(unparsedValue), "%d-%m-%Y");
            case 'text':
                return unparsedValue.replaceAll('<br>', '\n').replaceAll('<br/>', '\n').replaceAll('<b>', '').replaceAll('</b>', '')
            default:
                return unparsedValue;
        }
    }



    return (
        <div>
            <div className="row m-auto">
                {saleChannel?.sale_attributes && saleItem &&
                    <React.Fragment>
                        <SaleAttributes
                            saleAttributes={primarySaleAttributes}
                            saleItem={saleItem}
                            saleItemToParseValue={saleItemToParseValue}
                            setSaleItemToUpdate={setSaleItemToUpdate}
                            handleUpdateSaleItem={handleUpdateSaleItem}
                            disableSaleAttributeInput={disableSaleAttributeInput}
                            xlMarginRightIndexes={[]}
                            lgMarginRightIndexes={[]}
                            now={now}
                            renderSaleAttributeValue={renderSaleAttributeValue}
                        />

                        <SaleAttributes
                            saleAttributes={secondarySaleAttributes}
                            saleItem={saleItem}
                            saleItemToParseValue={saleItemToParseValue}
                            setSaleItemToUpdate={setSaleItemToUpdate}
                            handleUpdateSaleItem={handleUpdateSaleItem}
                            disableSaleAttributeInput={disableSaleAttributeInput}
                            xlMarginRightIndexes={base3Serie(102)}
                            lgMarginRightIndexes={multiples2(102)}
                            now={now}
                            renderSaleAttributeValue={renderSaleAttributeValue}
                        />
                    </React.Fragment>
                }

                <div className={`
                    col-12 col-lg-6 col-xl-4 border-bottom-aiG-light-gray-imp 
                    border-right-lg-${secondarySaleAttributes.length % 2 === 0 ? 'aiG-light-gray-imp' : 'none'}
                    border-right-xl-${base3Serie(102).includes(secondarySaleAttributes.length) ? 'aiG-light-gray-imp' : 'none'}
                    ${disableSaleAttributeInput(null, 'strong') ? 'cursor-not-allowed' : ''}
                `}>
                    <div className="d-block pl-2">
                        <SaleItemFormLabel
                            title={I18n.t('js.indexSaleItems.saleMethods.label').toUpperCase()}
                            message={I18n.t('js.indexSaleItems.saleMethods.description')}
                            id={`sale_method_${saleItem.id}_label`}
                            disabled={disableSaleAttributeInput(null, 'strong')}
                        />
                        {saleItem.editable ?
                            <select
                                className={`
                                    form-control sale-item-form-input
                                    sale-item-form-select ${!saleItem.sale_method ? 'sale-item-form-placeholder' : ''} 
                                    ${disableSaleAttributeInput(null, 'strong') ? 'opacity-0_3-imp' : ''}
                                `}
                                value={saleItem.sale_method ? saleItem.sale_method : ''}
                                name={`sale_method_${saleItem.id}`}
                                id={`sale_method_${saleItem.id}`}
                                disabled={disableSaleAttributeInput(null, 'strong')}
                                onChange={(e) => {
                                    handleUpdateSaleMethod(e.target.value)
                                }}
                            >
                                {saleChannel.sale_methods.map((saleMethod) => (
                                    <option value={saleMethod.method} key={saleMethod.method}>
                                        {I18n.t(`js.indexSaleItems.saleMethods.${saleMethod.method}`)}
                                    </option>
                                ))}
                            </select>
                            :
                            <p className="my-1">{I18n.t(`js.indexSaleItems.saleMethods.${saleItem.sale_method}`)}</p>
                        }
                    </div>
                </div>

                <div className={`
                    col-12 col-lg-6 col-xl-4 border-bottom-aiG-light-gray-imp 
                    border-right-xl-aiG-light-gray-imp
                    border-right-lg-${(secondarySaleAttributes.length + 1) % 2 === 0 ? 'aiG-light-gray-imp' : 'none'}
                    border-right-xl-${base3Serie(102).includes((secondarySaleAttributes.length + 1)) ? 'aiG-light-gray-imp' : 'none'}
                    ${disableSaleAttributeInput(null) ? 'cursor-not-allowed' : ''}
                `}>
                    <div className="d-block pl-2">
                        <SaleItemFormLabel
                            title={I18n.t(`js.indexSaleItems.amount.amount${saleItem.sale_method ? '_' + saleItem.sale_method : ''}`)}
                            message={I18n.t(`js.indexSaleItems.amount.description${saleItem.sale_method ? '_' + saleItem.sale_method : ''}`)}
                            id={`start_amount_${saleItem.id}_label`}
                            disabled={disableSaleAttributeInput(null)}
                        />
                        {saleItem.editable ?
                            <input
                                type="number"
                                min="0.01"
                                step="0.5"
                                value={saleItemToParseValue.start_amount ? saleItemToParseValue.start_amount : ''}
                                disabled={disableSaleAttributeInput(null)}
                                className={`form-control sale-item-form-input border-left-radius-3px-imp w-100 mb-1
                                            ${disableSaleAttributeInput(null) ? 'opacity-0_3-imp' : ''}`}
                                onChange={(e) => {
                                    setSaleItemToUpdate({ oldSaleItem: { ...saleItem }, updatedSaleItem: { ...saleItemToParseValue, start_amount: (!isDefined(e.target.value) || e.target.value >= 0 ? e.target.value : saleItem.start_amount) } })
                                }}
                                name={`start_amount_${saleItem.id}`}
                                id={`start_amount_${saleItem.id}`}
                                placeholder={I18n.t('js.indexSaleItems.placeholders.typeAValue')}
                            />
                            :
                            <p className="my-1">{parseAmount(saleItem.start_amount, 2, true)}{CURRENCY_EURO}</p>
                        }
                    </div>
                </div>

                {saleChannel?.sale_attributes && saleItem &&
                    <SaleAttributes
                        saleAttributes={otherSaleAttributes}
                        saleItem={saleItem}
                        saleItemToParseValue={saleItemToParseValue}
                        setSaleItemToUpdate={setSaleItemToUpdate}
                        handleUpdateSaleItem={handleUpdateSaleItem}
                        disableSaleAttributeInput={disableSaleAttributeInput}
                        xlMarginRightIndexes={base3Serie(102, (secondarySaleAttributes.length + 2) % 3)}
                        lgMarginRightIndexes={(secondarySaleAttributes.length + 2) % 2 === 0 ? multiples2(102) : notMultiples2(102)}
                        now={now}
                        renderSaleAttributeValue={renderSaleAttributeValue}
                    />
                }

                <div className={`d-none
                    ${(allSaleChannelAttributes(saleChannel, saleItem)) % 2 === 1 ? 'd-lg-flex col-lg-6' : 'd-lg-none'} 
                    ${(allSaleChannelAttributes(saleChannel, saleItem)) % 3 === 0 ? 'd-xl-none' : ((allSaleChannelAttributes(saleChannel, saleItem)) % 3 === 1 ? 'd-xl-flex col-xl-8' : 'd-xl-flex col-xl-4')} 
                    border-bottom-aiG-light-gray-imp`}>
                </div>


                {saleChannel?.couriers?.length > 0 &&
                    <React.Fragment>
                        <div className={`
                            col-12 col-xl-4 border-bottom-aiG-light-gray-imp border-right-xl-aiG-light-gray-imp
                            ${disableSaleAttributeInput(null, 'strong') ? 'cursor-not-allowed' : ''}`}
                        >
                            <div className="d-block pl-2 shipment_method_selector_container">
                                <SaleItemFormLabel
                                    title={I18n.t('js.indexSaleItems.shipmentMethod.labelCompact')}
                                    message={I18n.t('js.indexSaleItems.shipmentMethod.description')}
                                    disabled={disableSaleAttributeInput(null, 'strong')}
                                />
                                {saleItem.editable ?
                                    <select className={`
                                        form-control sale-item-form-input w-100 w-lg-50 w-xl-100
                                        sale-item-form-select 
                                        ${!saleItem.shipment_method ? 'sale-item-form-placeholder' : ''}
                                        ${disableSaleAttributeInput(null, 'strong') ? 'opacity-0_3-imp' : ''}
                                    `}
                                        id={`shipment_method_select_${saleItem.id}`}
                                        onChange={(e) => handleUpdateSaleItem({ ...saleItem, shipment_method: { id: e.target.value } })}
                                        value={saleItem.shipment_method?.id ? saleItem.shipment_method.id : ''}
                                        disabled={disableSaleAttributeInput(null, 'strong')}
                                    >
                                        <option value={""}>{I18n.t('js.indexSaleItems.shipmentMethod.noShipmentMethod')}</option>
                                        {nationalCouriers?.length > 0 &&
                                            <option value="new_shipment_method_national">{I18n.t('js.indexSaleItems.shipmentMethod.nationalShipmentMethod')}</option>
                                        }
                                        {internationalCouriers?.length > 0 &&
                                            <option value="new_shipment_method_international">{I18n.t('js.indexSaleItems.shipmentMethod.internationalShipmentMethod')}</option>
                                        }
                                    </select>
                                    :
                                    <p className="my-1">
                                        {saleItem.shipment_method?.id === 'new_shipment_method_national' ?
                                            I18n.t('js.indexSaleItems.shipmentMethod.nationalShipmentMethod')
                                            :
                                            saleItem.shipment_method?.id === 'new_shipment_method_international' ?
                                                I18n.t('js.indexSaleItems.shipmentMethod.internationalShipmentMethod')
                                                :
                                                isDefined(saleItem.shipment_method?.id) ?
                                                    I18n.t('js.indexSaleItems.listingForm.set')
                                                    :
                                                    I18n.t('js.indexSaleItems.shipmentMethod.noShipmentMethod')
                                        }
                                    </p>
                                }
                            </div>
                        </div>


                        {(nationalCouriers?.length > 0 || (isDefined(saleItem.shipment_method?.national) && saleItem.shipment_method.national.length > 0)) &&
                            <ShipmentMethodForm
                                saleItem={saleItem}
                                couriers={nationalCouriers}
                                category={'national'}
                                handleUpdateSaleItem={handleUpdateSaleItem}
                                safeShipmentMethod={safeShipmentMethod}
                                saleItemToUpdate={saleItemToUpdate}
                                setSaleItemToUpdate={setSaleItemToUpdate}
                                saleItemToParseValue={saleItemToParseValue}
                                disabled={disableSaleAttributeInput(null, 'strong')}
                            />
                        }

                        {(internationalCouriers?.length > 0 || (isDefined(saleItem.shipment_method?.international) && saleItem.shipment_method.international.length > 0)) &&
                            <React.Fragment>
                                <div className="d-none d-xl-flex col-xl-4 border-bottom-aiG-light-gray-imp border-right-lg-aiG-light-gray-imp border-right-xl-aiG-light-gray-imp" />
                                <ShipmentMethodForm
                                    saleItem={saleItem}
                                    couriers={internationalCouriers}
                                    category={'international'}
                                    handleUpdateSaleItem={handleUpdateSaleItem}
                                    safeShipmentMethod={safeShipmentMethod}
                                    saleItemToUpdate={saleItemToUpdate}
                                    setSaleItemToUpdate={setSaleItemToUpdate}
                                    saleItemToParseValue={saleItemToParseValue}
                                    disabled={disableSaleAttributeInput(null, 'strong')}
                                />
                            </React.Fragment>
                        }

                    </React.Fragment>
                }
            </div>
        </div>
    )
}

export default SaleForm